<div class="card-body">

  <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
  <button *ngIf="!InProccessing" (click)="Read_DeviceLetterList_Seleted()" type="button" class="btn btn-info"
    style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات</button>
  <button *ngIf="!InProccessing" type="button" (click)="openModal_Device(templateDevice)" class="btn btn-danger left">
    انتخاب دستگاه <i class="fa fa-cc-amex"></i> </button>

  <br>
  <br>

  <div class="table-responsive" >
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>#</th>
          <th>نام دستگاه</th>
          <th>تعداد</th>
          <th>مدت انقضاء</th>
          <th>ريال افزایش مدیر</th>
          <th>مبلغ واحد(ريال)</th>
          <th>جمع کل(ريال)</th>
          <th>ملاحظات</th>
          <th>توضیحات</th>
          <th>نمایش توضیحات</th>
          <th>امکانات</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of DeviceLetterList_Seleted">

          <tr>
            <td>{{DeviceLetterList_Seleted.indexOf(item)+1}}</td>
            <td>{{item.device_name}}</td>
            <td>{{item.tedad}}</td>
            <td>{{item.expiration_title}}</td>
            <td>{{item.incRailModir|number}}</td>
            <td>{{item.price|number}}</td>
            <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
            <td>{{item.price_dsc}}</td>
            <td>{{item.dscUser}}</td>
            <td>
              <p *ngIf="item.dscVisible" style="color: #489b39;">نمایش توضیحات </p>
              <p *ngIf="!item.dscVisible" style="color: crimson;">عدم نمایش توضیحات </p>
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a class="dropdown-item" style="cursor: pointer;" (click)="RemoveActivityDevice(item)"><i class="fa fa-remove"></i> حذف </a>
                  <a *ngIf="!item.dscVisible" style="cursor: pointer;" class="dropdown-item" (click)="SwichActivityDevice(item)"><i class="fa fa-eye"></i> نمایش توضیحات </a>
                  <a *ngIf="item.dscVisible" style="cursor: pointer;" class="dropdown-item" (click)="SwichActivityDevice(item)"><i class="fa fa-eye-slash"></i> عدم نمایش توضیحات </a>
                  </div>
                </div>
              </div>
               <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  
              </div>
            </td>

          </tr>
          <tr style="background:#d0d2db;">
            <td style="font-weight: bolder;" colspan="4">توضیحات مشتری</td>
            <td colspan="6">
              <input class="form-control" placeholder="اینجا تایپ کنید ..." type="text" [(ngModel)]="item.dscMission" />
            </td>
            <td>
              <button (click)="SubmitDeviceMissionDsc(item)" class="btn btn-info"><i class="fa fa-plus"></i>
                ثبت توضیحات</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>


</div>




<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات دستگاه های محل مشتری نامه '{{inner_Letter_id}}'
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">

      </div>

      <div class="table-responsive" style="max-height:300px ;">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام دستگاه</th>
              <th>تعداد</th>
              <th>مدت انقضاء</th>
              <th>ريال افزایش مدیر</th>
              <th>مبلغ واحد(ريال)</th>
              <th>جمع کل(ريال)</th>
              <th>ملاحظات</th>
              <th>توضیحات</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceLetterList">
              <td>{{DeviceLetterList.indexOf(item)+1}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.tedad}}</td>
              <td>{{item.expiration_title}}</td>
              <td>{{item.incRailModir|number}}</td>
              <td>{{item.price|number}}</td>
              <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dscUser}}</td>
              <td>
                <button (click)="Add_Device(item)" class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="Add_DeviceAll()" *ngIf="DeviceLetterList.length>0" class="btn btn-success"><i class="fa fa-check"></i> انتخاب همه موارد</button>
    <button *ngIf="!ProcssingDevice" type="button" (click)="Read_DeviceLetterList()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">بستن</button>
  </div>
</ng-template>